import * as tslib_1 from "tslib";
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { pick, uniqueId, isFunction } from 'lodash';
import { Manager, Arrow } from 'react-popper';
import PopoverTarget from './PopoverTarget';
import PopoverBody from './PopoverBody';
import "./Popover.css";

var Popover =
/** @class */
function (_super) {
  tslib_1.__extends(Popover, _super);

  function Popover(props) {
    var _this = _super.call(this, props) || this;

    _this.handleClickOutside = function (e) {
      var _a = _this.props,
          onClickOutside = _a.onClickOutside,
          ignoreList = _a.clickOutsideIgnoreClasses,
          ignoreCheck = _a.clickOutsideIgnoreChecker;
      var shouldTargetBeIgnored = ignoreCheck ? ignoreCheck(e) : ignoreList.some(function (cls) {
        return !!e.target.closest("." + cls);
      });
      if (shouldTargetBeIgnored) return;
      onClickOutside ? onClickOutside(e) : _this.togglePopover(e);
    };

    _this.handleBodyClick = function (e) {
      if (!_this.props.shouldPropagate) {
        e.stopPropagation();
      }
    };

    _this.togglePopover = function (e) {
      var togglePopover = _this.props.togglePopover;
      e && e.stopPropagation();

      if (togglePopover) {
        togglePopover(e);
      } else {
        _this.setState(function (state) {
          return {
            isOpen: !state.isOpen
          };
        });
      }
    };

    _this.targetClickOutsideIgnoreClass = uniqueId('nx-popover-click-outside-ignore');
    _this.state = {
      isOpen: props.isOpen
    };
    return _this;
  }

  Popover.prototype.componentWillReceiveProps = function (nextProps) {
    if (this.state.isOpen !== nextProps.isOpen) {
      this.setState({
        isOpen: nextProps.isOpen
      });
    }
  };

  Popover.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        children = _a.children,
        body = _a.body,
        arrow = _a.arrow,
        popper = _a.popper,
        openOnClick = _a.openOnClick,
        onMouseEnter = _a.onMouseEnter,
        onMouseLeave = _a.onMouseLeave,
        managerClassName = _a.managerClassName,
        targetClassName = _a.targetClassName,
        targetComponent = _a.targetComponent,
        inline = _a.inline,
        cover = _a.cover,
        managerTag = _a.managerTag;
    var isOpen = this.state.isOpen;
    var finalManagerClassName = cx('nx-popover-manager', managerClassName, {
      'nx-popover-manager--inline': inline,
      'nx-popover-manager--open': isOpen,
      'nx-popover-manager--closed': !isOpen
    });
    var targetProps = {
      className: cx(this.targetClickOutsideIgnoreClass, targetClassName),
      component: targetComponent
    };

    if (openOnClick) {
      targetProps.onClick = this.togglePopover;
    }

    var bodyProps = {
      className: className,
      arrow: arrow,
      popper: popper,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      togglePopover: this.togglePopover,
      handleBodyClick: this.handleBodyClick,
      handleClickOutside: this.handleClickOutside,
      targetClickOutsideIgnoreClass: this.targetClickOutsideIgnoreClass,
      cover: cover
    };
    return React.createElement(Manager, {
      className: finalManagerClassName,
      tag: managerTag
    }, React.createElement(PopoverTarget, tslib_1.__assign({}, targetProps), isFunction(children) ? children({
      isOpen: isOpen
    }) : children), isOpen && React.createElement(PopoverBody, tslib_1.__assign({}, bodyProps), body));
  };

  Popover.propTypes = tslib_1.__assign({}, pick(PopoverBody.propTypes, ['arrow', 'popper', 'onMouseEnter', 'onMouseLeave']), {
    //@ts-ignore
    body: PopoverBody.propTypes.children,
    className: PropTypes.string,
    managerClassName: PropTypes.string,
    targetClassName: PropTypes.string,
    targetComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),

    /** Can be one of:
     * 1. a node
     * 2. a function, which gets isOpen and returns a node
     * 3. a function,
     *    which gets isOpen and returns a function,
     *    which gets refs and returns a node
     */
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
    isOpen: PropTypes.bool,
    openOnClick: PropTypes.bool,
    shouldPropagate: PropTypes.bool,
    inline: PropTypes.bool,

    /** Padding-less Popover theme */
    cover: PropTypes.bool,
    clickOutsideIgnoreClasses: PropTypes.arrayOf(PropTypes.string),
    clickOutsideIgnoreChecker: PropTypes.func,
    onClickOutside: PropTypes.func,
    togglePopover: PropTypes.func,
    managerTag: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
  });
  Popover.defaultProps = {
    children: 'Click me!',
    body: 'Popover body',
    arrow: React.createElement(Arrow, null),
    isOpen: false,
    openOnClick: true,
    shouldPropagate: false,
    inline: false,
    cover: false,
    clickOutsideIgnoreClasses: [],
    managerTag: false
  };
  return Popover;
}(React.Component);

export default Popover;

try {
  // @ts-ignore
  Popover.__docgenInfo = {
    "description": "",
    "displayName": "Popover",
    "props": {
      "isOpen": {
        "defaultValue": {
          value: "false"
        },
        "description": "",
        "name": "isOpen",
        "required": true,
        "type": {
          "name": "boolean"
        }
      },
      "managerClassName": {
        "defaultValue": null,
        "description": "",
        "name": "managerClassName",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "className": {
        "defaultValue": null,
        "description": "",
        "name": "className",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "openOnClick": {
        "defaultValue": {
          value: "true"
        },
        "description": "",
        "name": "openOnClick",
        "required": true,
        "type": {
          "name": "boolean"
        }
      },
      "inline": {
        "defaultValue": {
          value: "false"
        },
        "description": "",
        "name": "inline",
        "required": true,
        "type": {
          "name": "boolean"
        }
      },
      "onClickOutside": {
        "defaultValue": null,
        "description": "",
        "name": "onClickOutside",
        "required": false,
        "type": {
          "name": "((event: MouseEvent<Element>) => void) | undefined"
        }
      },
      "clickOutsideIgnoreClasses": {
        "defaultValue": null,
        "description": "",
        "name": "clickOutsideIgnoreClasses",
        "required": true,
        "type": {
          "name": "string[]"
        }
      },
      "clickOutsideIgnoreChecker": {
        "defaultValue": null,
        "description": "",
        "name": "clickOutsideIgnoreChecker",
        "required": false,
        "type": {
          "name": "((e: MouseEvent<Element>) => boolean) | undefined"
        }
      },
      "shouldPropagate": {
        "defaultValue": {
          value: "false"
        },
        "description": "",
        "name": "shouldPropagate",
        "required": true,
        "type": {
          "name": "boolean"
        }
      },
      "targetClassName": {
        "defaultValue": null,
        "description": "",
        "name": "targetClassName",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "targetComponent": {
        "defaultValue": null,
        "description": "",
        "name": "targetComponent",
        "required": false,
        "type": {
          "name": "string | ComponentClass<any, any> | StatelessComponent<any> | undefined"
        }
      },
      "body": {
        "defaultValue": {
          value: "Popover body"
        },
        "description": "",
        "name": "body",
        "required": true,
        "type": {
          "name": "string | number | ReactElement<any> | ((props: { togglePopover: TogglePopoverType; }) => void) | undefined"
        }
      },
      "popper": {
        "defaultValue": null,
        "description": "",
        "name": "popper",
        "required": true,
        "type": {
          "name": "IPopperProps"
        }
      },
      "arrow": {
        "defaultValue": null,
        "description": "",
        "name": "arrow",
        "required": true,
        "type": {
          "name": "false | ReactElement<ArrowProps> | undefined"
        }
      },
      "onMouseLeave": {
        "defaultValue": null,
        "description": "",
        "name": "onMouseLeave",
        "required": true,
        "type": {
          "name": "((event: MouseEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "onMouseEnter": {
        "defaultValue": null,
        "description": "",
        "name": "onMouseEnter",
        "required": true,
        "type": {
          "name": "((event: MouseEvent<HTMLDivElement>) => void) | undefined"
        }
      },
      "cover": {
        "defaultValue": {
          value: "false"
        },
        "description": "",
        "name": "cover",
        "required": true,
        "type": {
          "name": "boolean | undefined"
        }
      },
      "togglePopover": {
        "defaultValue": null,
        "description": "",
        "name": "togglePopover",
        "required": false,
        "type": {
          "name": "TogglePopoverType | undefined"
        }
      },
      "managerTag": {
        "defaultValue": {
          value: "false"
        },
        "description": "",
        "name": "managerTag",
        "required": false,
        "type": {
          "name": "string | boolean | undefined"
        }
      }
    }
  };
} catch (__react_docgen_typescript_loader_error) {}